import UsersListTable from './UsersListTable';

export default UsersListTable;
